module.exports = __webpack_public_path__ + "static/media/disc-drive.8560c0f0.svg";